import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { CaseStudyProps } from "@/lib/types";
import { cn } from "@/lib/utils/utils";
import ViewCaseStudyLink from "./ViewCaseStudyLink";
interface SelectedWorkCardProps {
  data: CaseStudyProps;
  /** Height comes from the caller so a row of cards can stagger. */
  className?: string;
}
const SelectedWorkCard = t0 => {
  const $ = _c(37);
  const {
    data,
    className
  } = t0;
  let t1;
  if ($[0] !== data.name || $[1] !== data.title) {
    t1 = data.name ?? data.title.split(/[—–]/)[0].trim();
    $[0] = data.name;
    $[1] = data.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const projectName = t1;
  let t2;
  if ($[3] !== data.bgColor) {
    t2 = {
      backgroundColor: data.bgColor
    };
    $[3] = data.bgColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className) {
    t3 = cn("flex w-full flex-col gap-6 rounded-3xl border border-black/10 p-6 text-card-foreground md:p-8 lg:flex-row lg:items-stretch lg:gap-10 lg:p-10", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== data.tag) {
    t4 = <span className="font-mono text-[10px] font-bold tracking-[0.24em] uppercase opacity-65">{data.tag}</span>;
    $[7] = data.tag;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== projectName) {
    t5 = <h3 className="text-2xl leading-[0.9] font-black tracking-tighter uppercase md:text-4xl xl:text-5xl">{projectName}</h3>;
    $[9] = projectName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== data.description) {
    t6 = <p className="max-w-md text-sm leading-relaxed opacity-75 md:text-base">{data.description}</p>;
    $[11] = data.description;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="space-y-3">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `/case-study/${data.slug}`;
  const t9 = `View ${projectName} Case Study`;
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <ViewCaseStudyLink href={t8} label={t9} />;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t4 || $[21] !== t7) {
    t11 = <div className="flex flex-col justify-between gap-6 lg:flex-1">{t4}{t7}{t10}</div>;
    $[19] = t10;
    $[20] = t4;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = `${projectName} — ${data.tag} project by Octarnal`;
  let t13;
  if ($[23] !== data.image || $[24] !== t12) {
    t13 = <div className="relative min-h-40 w-full flex-1 overflow-hidden rounded-2xl"><Image src={data.image} alt={t12} fill={true} sizes="(max-width: 1024px) 100vw, 520px" className="object-cover" /></div>;
    $[23] = data.image;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== data.metric || $[27] !== data.metricLabel) {
    t14 = data.metric && <p className="text-2xl leading-none font-black tracking-tighter md:text-4xl">{data.metric}<span className="mt-2.5 block font-mono text-[9px] leading-relaxed font-normal tracking-[0.2em] uppercase opacity-65">{data.metricLabel}</span></p>;
    $[26] = data.metric;
    $[27] = data.metricLabel;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="flex min-h-0 w-full flex-1 flex-col gap-5 lg:w-[42%] lg:flex-none">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15 || $[34] !== t2 || $[35] !== t3) {
    t16 = <article style={t2} className={t3}>{t11}{t15}</article>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t2;
    $[35] = t3;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default SelectedWorkCard;